exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7edaf4e2]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.input-group .input-group-prepend .input-group-text[data-v-7edaf4e2] {\n  background: #aa4121;\n  border-color: #aa4121;\n  color: #fff;\n}\n.input-group input[data-v-7edaf4e2] {\n  color: #aa4121;\n}\nbutton[data-v-7edaf4e2] {\n  background-color: #ccc;\n  border: none;\n  color: #aa4121;\n  border-radius: 20px;\n  padding: 8px 15px;\n}", ""]);

// exports
